import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export interface IProductAdvertiser {
    advertiser: {
        tradeName: string,
        phone: string,
        phoneCode: string,
        location: string,
        image: string
    }
    handleEngagement: () => void;
    isMobile: boolean;
    price: String;
    isLoading: boolean;
    showButton: boolean;
}

export const ProductAdvertiser: React.FC<IProductAdvertiser> = (data) => {
    const { t } = useTranslation('product');
    const { advertiser } = data;
    return (
        <Row className={`rounded bg-white p-4 ${data.isMobile ? "" : "mt-4 shadow"} row-cols-auto"`}>
            <Col style={{ marginRight: -15 }}>
                <h5>{t('about_advertiser')}</h5>
                <hr />
                <Row className="row-cols-auto">
                    {advertiser.image &&
                        <Col>
                            <img
                                alt={"Sua Foto"}
                                src={advertiser.image}
                                className={`rounded-circle ms-2 ${!data.isMobile ? `d-none d-md-inline-flex` : `d-md-none`}`}
                                width={50}
                                height={50}
                                referrerPolicy="no-referrer"
                            />
                        </Col>
                    }
                    <Col>
                        <h6>{advertiser.tradeName}</h6>
                        <p><small>{advertiser.location}</small></p>
                    </Col>
                </Row>
                <h2 style={{ letterSpacing: -2 }}>
                    {advertiser.phoneCode ? <small style={{ fontSize: 20 }}>{advertiser.phoneCode}</small> : null} {advertiser.phone}{data.showButton &&
                        <Button
                            style={{ backgroundColor: "#FF961B", borderColor: "#FF961B", boxShadow: "-15px 0 12px white" }}
                            onClick={data.handleEngagement}
                        >
                            {data.isLoading ? <Spinner animation="border" size="sm" /> : t('seePhoneNumber')}
                        </Button>
                    }
                </h2>
                <small>
                    <p
                        dangerouslySetInnerHTML={{
                            __html: t('shippingDetails', { advertiserName: advertiser.tradeName })
                        }}
                    />
                </small>
            </Col>
        </Row>
    );
}